import { List } from 'immutable'
import * as actions from './actions'
import { Record } from '../transit'

const State = Record({
  location: [{ pathname: '/' }],
  storageLoaded: false,
  errors: new List(),
  navigationVisible: false,
  navigationOverlayVisible: false,
  backAndroidPress: null,
  version: '',
}, 'app')

const appReducer = (state = new State(), action) => {
  // This is how we can handle all async actions rejections.
  if (action.type.endsWith('_ERROR')) {
    const errors = (action.payload && action.payload.errors) || action.payload
    return state.set('errors', new List(errors))
  }

  switch (action.type) {
    case actions.APP_LOAD_VERSION_SUCCESS:
      return state.set('version', action.payload.data && action.payload.data.version)

    case actions.APP_SET_LOCATION:
      return state.set('location', action.payload.location)

    case actions.SET_SCROLL_LOCATION:
      return state.set('navigationOverlayVisible', action.payload.location > 50)

    case actions.APP_STORAGE_LOAD:
      return state.set('storageLoaded', true)

    case actions.TOGGLE_NAVIGATION:
      return state.set('navigationVisible', !state.get('navigationVisible'))

    case actions.SET_BACK_ANDROID_PRESS:
      return state.set('backAndroidPress', action.payload.backAndroidPress)

    case actions.RESET_BACK_ANDROID_PRESS:
      return state.set('backAndroidPress', null)

    default:
      return state
  }
}

export default appReducer



// WEBPACK FOOTER //
// ./src/common/app/reducer.js